import { HumanGreetingIcon } from './HumanGreetingIcon';

/**
 * author: Google
 * id 59728070-C172-44A6-9076-5D5C29D08880
 * name human-greeting
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-greeting.svg
 * tags
 * - People / Family 
 */
export const HumanHelloIcon = HumanGreetingIcon;
export default HumanHelloIcon